import { compose } from 'redux';
import withAnalytics from '../../../containers/redux/withAnalytics';
import FeedGrid from './FeedGrid';

const ComposedFeedGrid = compose(withAnalytics)(FeedGrid);

ComposedFeedGrid.displayName = FeedGrid.displayName;
ComposedFeedGrid.fragment = FeedGrid.fragment;

export default ComposedFeedGrid;
export * from './FeedGrid';
